import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { openCookieSettings } from "../lib/consent";

const legalLinks = [
  { to: "/ochrana-osobnich-udaju", label: "Ochrana osobních údajů" },
  { to: "/cookies", label: "Zásady cookies" },
  { to: "/obchodni-podminky", label: "Obchodní podmínky" },
  { to: "/reklamacni-rad", label: "Reklamační řád" },
  { to: "/odstoupeni-od-smlouvy", label: "Odstoupení od smlouvy" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative z-10 border-t border-white/10 bg-[#050505] pt-20 pb-10">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="font-display text-3xl mb-4">
            ALUKOLA<span className="text-[#ff3b30]">-BAZAR</span>
          </div>
          <p className="text-white/50 text-sm leading-relaxed max-w-xs">
            M + J s.r.o. — specialista na originální alu kola, pneumatiky a vozidla od roku 2002.
          </p>
        </div>

        <div>
          <h4 className="font-head uppercase tracking-[0.2em] text-xs text-white/40 mb-5">Navigace</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/katalog" className="hover:text-white transition-colors">Katalog</Link></li>
            <li><Link to="/katalog?category=kola" className="hover:text-white transition-colors">Alu kola</Link></li>
            <li><Link to="/katalog?category=kusovky" className="hover:text-white transition-colors">Alu kola kusovky (1–3 ks)</Link></li>
            <li><Link to="/katalog?category=pneu" className="hover:text-white transition-colors">Pneumatiky</Link></li>
            <li><Link to="/katalog?category=poklicky" className="hover:text-white transition-colors">Pokličky</Link></li>
            <li><Link to="/katalog?category=dily" className="hover:text-white transition-colors">Autodíly</Link></li>
            <li><Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-head uppercase tracking-[0.2em] text-xs text-white/40 mb-5">Kontakt</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[#ff3b30]" /> Truhlářská 893, 251 68 Kamenice - Těptín</li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-[#ff3b30]" /> <a href="tel:+420777181818" className="hover:text-white">+420 777 181 818</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#ff3b30]" /> <a href="mailto:alukola-bazar@seznam.cz" className="hover:text-white">alukola-bazar@seznam.cz</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-head uppercase tracking-[0.2em] text-xs text-white/40 mb-5">Otevírací doba</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-center gap-2"><Clock size={14} className="text-[#ff3b30]" /> Po telefonické dohodě</li>
            <li className="pl-6">Pondělí – Neděle: 7:00 – 23:00</li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1500px] mx-auto px-5 md:px-10 mt-16 pt-8 border-t border-white/10">
        <div className="flex flex-wrap gap-x-6 gap-y-3 mb-6" data-testid="footer-legal-links">
          {legalLinks.map((l) => (
            <Link key={l.to} to={l.to} className="text-xs text-white/50 hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
          <button
            type="button"
            data-testid="footer-cookie-settings"
            onClick={openCookieSettings}
            className="text-xs text-white/50 hover:text-white transition-colors"
          >
            Nastavení cookies
          </button>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40 pt-6 border-t border-white/10">
          <span>© {new Date().getFullYear()} M + J s.r.o. — IČ 27069354 · DIČ CZ27069354</span>
          <span>Vytvořeno s péčí pro milovníky aut.</span>
        </div>
      </div>
    </footer>
  );
}
